/*
 * @Author: yanghailong
 * @Date: 2023-08-23 09:06:33
 * @Last Modified by: yanghailong
 * @Last Modified time: 2025-03-27 11:29:39
 */
import Konva from "konva"
import { randomUUID } from './utils/index.js'

export class GraphElementPort {

  constructor(x, y, width, height, portSize) {
    this.portUp = new Konva.Circle({
      x: x + width / 2,
      y: y,
      radius: portSize,
      fill: 'white',
      stroke: '#00E8FF',
      strokeWidth: 1,
      name: 'port',
      dir: 'up',
      visible: false,
      strokeScaleEnabled: false,
      uuid: randomUUID(),
    })
    this.portDown = new Konva.Circle({
      x: x + width / 2,
      y: y + height,
      radius: portSize,
      fill: 'white',
      stroke: '#00E8FF',
      strokeWidth: 1,
      name: 'port',
      dir: 'down',
      visible: false,
      strokeScaleEnabled: false,
      uuid: randomUUID(),
    })
  }

  update(x, y, width, height) {
    this.portUp.x(x + width / 2)
    this.portUp.y(y)
    this.portDown.x(x + width / 2)
    this.portDown.y(y + height)
  }

  toJSON() {
    return {
      portUp: this.portUp.attrs.uuid,
      portDown: this.portDown.attrs.uuid,
    }
  }

  show() {
    this.portUp.show()
    this.portDown.show()
  }

  hide() {
    this.portUp.hide()
    this.portDown.hide()
  }

  remove(port) {
    if (port == this.portUp) {
      this.portUp.remove()
    }
    if (port == this.portDown) {
      this.portDown.remove()
    }
  }
}
